import React from 'react'
import { FaExclamationTriangle, FaEdit } from 'react-icons/fa'
import { Box, Heading, Text, Icon, SimpleTable, Button, Badge, Stack } from '@/components/lib'
import useStore from '../../../store'
import utils from '../../../utils/utils'

import { APPROVAL_TYPES } from './Approval'

const Overview = ({ trial, fields, data, setTab }) => {
  const { user } = useStore()

  const rows = []
  fields.filter(f => data[f.key] || f.required).forEach(field => rows.push([
    field.label,
    <Box key={field.key}>
      {field.required && !data[field.key] &&
        <Icon color='orange.400'><FaExclamationTriangle /></Icon>}
      <Text fontSize={field.type === 'textarea' ? 'sm' : 'md'}>
        {data[field.key]}
      </Text>
    </Box>,
    utils.canManageTrial(user, trial) &&
      <Box key={field.key}>
        <Button size='sm' variant='ghost' colorPalette='primary' onClick={e => setTab(field.section)}>
          <Icon><FaEdit /></Icon> Edit
        </Button>
      </Box>
  ]))
  data.approvals?.forEach(approval => rows.push([
    <Box key={approval.id}>
      <Heading size='sm'>Approval</Heading>
      {APPROVAL_TYPES.find(t => t.value === approval.type)?.label || 'Unknown approval type'}
    </Box>,
    <Stack gap={2} key={approval.id}>
      <Box>
        {(!approval.status || approval.status === 'notSubmitted') && <Badge colorPalette='gray'>Not Submitted</Badge>}
        {approval.status === 'submitted' && <Badge colorPalette='yellow'>Submitted</Badge>}
        {approval.status === 'approved' && <Badge colorPalette='green'>Approved</Badge>}
      </Box>

      <Stack spacing={1}>
        {approval.submissionDate && <Text>Submitted: {utils.formatDate(approval.submissionDate)}</Text>}
        {approval.approvalDate && <Text>Approved: {utils.formatDate(approval.approvalDate)}</Text>}
        {approval.reference && <Text>Reference: {approval.reference}</Text>}
      </Stack>
    </Stack>,
    utils.canManageTrial(user, trial) &&
      <Box key={approval.id}>
        <Button size='sm' variant='ghost' colorPalette='primary' onClick={e => setTab('approval')}>
          <Icon><FaEdit /></Icon> Edit
        </Button>
      </Box>
  ]))

  return (
    <Stack gap={5}>
      <Box>
        <Heading as='h2' size='md'>About your trial</Heading>
        <Text>Use this section to describe your project, its sponsor, approvals, and other relevant information.</Text>
      </Box>

      <SimpleTable
        tableProps={{ variant: 'simple' }}
        headers={[]}
        rows={rows}
      />
    </Stack>
  )
}

export default Overview
